{
  "name": "tb-app-ui",
  "version": "10.4.2",
  "scripts": {
    "start": "npx ng serve",
    "build": "npx ng build --configuration production",
    "test": "npx ng test",
    "lint": "npx ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.0.4",
    "@angular/cdk": "^20.0.3",
    "@angular/common": "^20.0.4",
    "@angular/compiler": "^20.0.4",
    "@angular/core": "^20.0.4",
    "@angular/forms": "^20.0.4",
    "@angular/localize": "^20.0.4",
    "@angular/material": "^20.0.3",
    "@angular/material-date-fns-adapter": "^20.0.3",
    "@angular/platform-browser": "^20.0.4",
    "@angular/platform-browser-dynamic": "^20.0.4",
    "@angular/router": "^20.0.4",
    "@fontsource/roboto": "^5.2.5",
    "@kolkov/angular-editor": "3.0.0-beta.0",
    "@ngxs/devtools-plugin": "19.0.0",
    "@ngxs/logger-plugin": "19.0.0",
    "@ngxs/router-plugin": "19.0.0",
    "@ngxs/storage-plugin": "19.0.0",
    "@ngxs/store": "19.0.0",
    "@trackback/widgets": "10.2.0",
    "angularx-qrcode": "20",
    "chart.js": "4",
    "chartjs-plugin-datalabels": "^2.2.0",
    "classlist.js": "^1.1.20150312",
    "core-js": "^2.6.12",
    "date-fns": "^2.30.0",
    "date-fns-tz": "2",
    "file-saver": "^2.0.5",
    "html2canvas": "^1.4.1",
    "immer": "^10.0.2",
    "jspdf": "^3.0.1",
    "lodash-es": "^4.17.21",
    "material-icons": "^1.13.14",
    "ng2-charts": "8",
    "ngx-mat-select-search": "8",
    "rxjs": "^6.5.3 || ^7.4.0",
    "tslib": "^2.0.0",
    "type-fest": "^4.35.0",
    "web-animations-js": "^2.3.2",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.0.3",
    "@angular-eslint/builder": "19",
    "@angular-eslint/eslint-plugin": "19",
    "@angular-eslint/eslint-plugin-template": "19",
    "@angular-eslint/schematics": "19",
    "@angular-eslint/template-parser": "19",
    "@angular/cli": "^20.0.3",
    "@angular/compiler-cli": "^20.0.4",
    "@angular/language-service": "^20.0.4",
    "@types/file-saver": "^2.0.5",
    "@types/jest": "^29.5.8",
    "@types/lodash-es": "4.17.3",
    "@types/node": "22",
    "@typescript-eslint/eslint-plugin": "^8.31.1",
    "@typescript-eslint/parser": "^8.31.1",
    "eslint": "^9.25.1",
    "eslint-config-prettier": "^10.1.2",
    "eslint-plugin-prettier": "^5.0.1",
    "jest": "^29.7.0",
    "jest-junit": "^16.0.0",
    "jest-preset-angular": "^14.0.3",
    "ng-packagr": "^20.0.1",
    "prettier": "^3.0.3",
    "prettier-eslint": "^16.1.2",
    "ts-essentials": "^10.0.0",
    "ts-expect": "^1.3.0",
    "ts-node": "~7.0.0",
    "typescript": ">=5.5.0 <5.9.0"
  },
  "jest-junit": {
    "outputDirectory": "./junit"
  }
}
